import React from "react";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import { isDebugEnabled } from "./debug";
import { sanitizeError, sanitizeBreadcrumb, redactedKeys } from "./telemetry-privacy";

if (!isDebugEnabled(process.env.NEXT_PUBLIC_DEBUG) && process.env.NEXT_PUBLIC_BUGSNAG_API_KEY) {
  Bugsnag.start({
    apiKey: process.env.NEXT_PUBLIC_BUGSNAG_API_KEY,
    plugins: [new BugsnagPluginReact(React)],
    collectUserIp: false,
    generateAnonymousId: false,
    autoTrackSessions: false,
    enabledBreadcrumbTypes: ["navigation", "request"],
    redactedKeys,
    onError: sanitizeError,
    onBreadcrumb: sanitizeBreadcrumb,
    onSession: () => false,
  });
}

export default Bugsnag;
